import { DispositionTypes, Notifications, QuickLinks } from '.'
import { Issues } from '../../CIMSModule/instances'
import { CIMSPageItem } from '../CIMSPageItem'

export const IssueTracker = new CIMSPageItem({
  id: '8ba79e15-2910-4a26-946f-98b1a4781f1d',
  module: Issues,
  name: 'Issue Tracker',
  pathname: 'tracker',
  linkable: true,
})
export const IssueTypes = new CIMSPageItem({
  id: '904652f6-fcde-4a3a-9c8c-2c233d1495eb',
  module: Issues,
  name: 'Types',
  pathname: 'types',
})
export const IssueDispositionTypes = DispositionTypes({
  id: '673880d0-bdc8-43c5-850e-78379741dd71',
  module: Issues,
})
export const IssueQuickLinks = QuickLinks({
  id: 'a14ec9fd-247a-4011-a8b4-faa55afd0902',
  module: Issues,
})
export const IssueNotifications = Notifications({
  id: '97515620-61fe-47ae-b8c3-02307643380f',
  module: Issues,
})

export type IssuePageItem =
  | typeof IssueTracker
  | typeof IssueTypes
  | typeof IssueDispositionTypes
  | typeof IssueQuickLinks
  | typeof IssueNotifications
